import React, { Component } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';
import {
  addEntryPoint,
  getByDotNotation,
  getElementComponentName
} from '@/utils/custo-utils';
import { addMediaQueryRes } from './tools';
import { actions as custoActions } from '@/reducers/custo-reducer';
import { actions as mainActions } from '@gerenciatd/next.app-controller.reducers-sagas.main-reducer-n';
import { actions as modalActions } from '@gerenciatd/next.app-controller.reducers-sagas.modals-reducer'

const EditModal = dynamic(() => import('./edit-modal'))

class PPCCMS extends Component {
  constructor(props){
    super(props);
    const { creativityId } = props;
    this.fakeCssName = `custofake-${process.env.NEXT_PUBLIC_PROJECT_ID}-${creativityId}`;
    this.rateLimit = 1;
    this.firstTimeRenderWithInfo = true;
    this.state = {}
  }

  getCssFake = ({loading=true}) => {
    const res = [];
    const { fakeLoadingProps } = this.props;
    let loadingSyteCss = '';

    if(loading) {
      loadingSyteCss = `
        border-radius: 5px;
        background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
        background-size: 200% 100%;
        animation: 1s shine linear infinite;
      `
    }
    let desktop = '';
    if (fakeLoadingProps && fakeLoadingProps.desktop ) {
      desktop=addMediaQueryRes({
        selector: `.${this.fakeCssName}`,
        styleStr: `min-height: ${fakeLoadingProps.desktop};${loadingSyteCss}`,
        device: 'desktop',
      })
    }
    res.push(desktop);
    let tablet = ''
    if (fakeLoadingProps && fakeLoadingProps.tablet ) {
      tablet=addMediaQueryRes({
        selector: `.${this.fakeCssName}`,
        styleStr: `min-height: ${fakeLoadingProps.tablet};${loadingSyteCss}`,
        device: 'tablet',
      })
    }
    res.push(tablet);
    let mobile = ''
    if (fakeLoadingProps && fakeLoadingProps.mobile ) {
      mobile = addMediaQueryRes({
        selector: `.${this.fakeCssName}`,
        styleStr: `min-height: ${fakeLoadingProps.mobile}; ${loadingSyteCss}`,
        device: 'mobile',
      })
    }
    res.push(mobile);
    return res;
  }
  /*
   para actividades que sean en cliente
   */
  shouldComponentUpdate(nextProps){
    const { custoParams: nextCustoParams } = nextProps;
    const{ custoParams, creativities,kind, creativityId, allowEdit, applySessionDraft, getCreativity  } = this.props;
    const cndInfo = creativities && !creativities[creativityId];
    const cndCustoParams = custoParams !== nextCustoParams;
    const cndActivityKind= kind === 'activity';
    if (cndCustoParams && cndInfo && cndActivityKind && this.rateLimit > 0) {
      this.rateLimit = this.rateLimit - 1;
      // en el modo edición
      if (allowEdit){
        applySessionDraft({creativityId, kind, build: false});
      } else {
        getCreativity({creativityId, kind, build: false});
      }
    }
    
    // creatividades que se necesitan refrescar para tener overides porque venian de servidor
    // sino hubieran caido en didmount
    const cndCreativityKind = kind === 'creativity';
    if (allowEdit && cndCreativityKind) { 
      const { creativitiesOverride } = this.props;
      if (creativitiesOverride && !creativitiesOverride[creativityId] && this.rateLimit > 0) {
        this.rateLimit = this.rateLimit - 1;
        applySessionDraft({creativityId, kind, build: false});
      }
    }

    
    // no aplico optimizaciones añadidas
    return true;
  }

  // para creatividades en cliente (no va a haber por lo que modo edición)
  componentDidMount() {
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    const isEnvThatNeedsReload = currentEnv !== 'prod';
    const { creativityId, kind, creativities, getCreativity } = this.props;
    const isCreativity = kind ==='creativity';
    // common properties
    // props about behaviour rehydratate coming soon
    const { allowEdit, applySessionDraft } = this.props;
    if (isCreativity && allowEdit) {
      // mundo de edición
      applySessionDraft({creativityId, kind, build: false});
    } else if(isCreativity && creativities && (!creativities[creativityId] || isEnvThatNeedsReload)) {
      // comportamiento común
      // si mi entorno es dev o qa tengo que ejecutarme para ver la ultima contribución
      getCreativity({creativityId, kind, build: false});
      // si pido info y testoy en cliente puedo crear su fake en función
    }
  }


  handleEditModal = (entryPoint) => {
    const {
      launchEditModal,
      creativityId,
      creativitiesOverride,
      setDraftChange,
    } = this.props;
    const componentName = getElementComponentName(entryPoint);
    // hay que mandar la info mergeada para que el formulario se inicialice, pero en el entry point indicado
    const componentInfo = getByDotNotation(creativitiesOverride[creativityId], entryPoint);
    launchEditModal({
      id: 'edit',
      type: 'MODAL',
      Element2Show: EditModal,
      elementProps: {
        entryPoint,
        creativityId,
        componentName,
        componentInfo: componentInfo,
        setDraftChange,
      },
      modalProps: {
        contentPosition: 'right--center',
        opacityLayoutColor: 'black05',
        inSceneEffect: 'fadeIn',
        outSceneEffect: 'fadeOut',
        closeByClickingOutside: true,
      }
    })
  }
  // utils.common
  createCustoDescObject = () => {
    return {
      handler: this.handleEditModal,
      entryPoint: '',
      addEntryPoint,
    }
  }

  sendEventsOnRender(creativityProps){
    const { sendCmsEvent, creativityId } = this.props;
    if(sendCmsEvent) {
      let componentName = creativityId;
      if (creativityId === 'LightHouse_Home_Banner_Actividad') {
        componentName = 'bannerdistrihome';
      }

      if (creativityId === 'LightHouse_Destacados_Actividad') {
        componentName = 'productos-destacados';
      }

      let { taggingInfo } = creativityProps;
      taggingInfo = {
        ...taggingInfo,
        'event-type': 'print-success',
        componentName,
      }
      if(taggingInfo && !taggingInfo.componentContent){
        taggingInfo.componentContent = '';
      }
      if(taggingInfo && !taggingInfo.componentVariation){
        taggingInfo.componentVariation = '';
      }
      sendCmsEvent(taggingInfo);
    }
  }
  
  renderComponent({Component, creativityProps, custoObjectInfo}){
    const { kind, dictionary } = this.props;
    if(this.firstTimeRenderWithInfo && creativityProps && kind === 'activity') {
      this.firstTimeRenderWithInfo = false;
      this.sendEventsOnRender(creativityProps);
    }    

    return (
      <div className={this.fakeCssName}>
        <Component {...creativityProps} dictionary={dictionary} custoObjectInfo={custoObjectInfo} />
      </div>
    )
  }

 
  render(){
    const { allowEdit, editMode, Component, creativities, creativitiesOverride, creativityId, rawData } = this.props;
    const hasInfo = creativities && creativities[creativityId];
    const mediasFakesQueries = this.getCssFake({
      loading: !hasInfo
    });

    if (rawData && !allowEdit){
      return this.renderComponent({Component, creativityProps: rawData});
    }


    // fake para renderización en cliente y fake serviddor
    if (!hasInfo) {
      return (
        <>
          <Head>
            <style>{`
              ${mediasFakesQueries[0]}
              ${mediasFakesQueries[1]}
              ${mediasFakesQueries[2]}
            `}</style>
          </Head> 
          <div className={`${this.fakeCssName}`} />
        </>
      )
    }

    // renderizado para edición
    let custoObjectInfo = null;
    let creativityProps = creativities[creativityId]
    if (editMode){
      custoObjectInfo = this.createCustoDescObject();
      creativityProps =  creativitiesOverride[creativityId]
    }

    if (allowEdit) {
      return (
        <div className="editable-component">
          {this.renderComponent({Component, creativityProps, custoObjectInfo})}
        </div>
      )
    }


    // render al uso
    return (
      <>
        {this.renderComponent({Component, creativityProps, custoObjectInfo})}
        <Head>
          <style>{`
            ${mediasFakesQueries[0]}
            ${mediasFakesQueries[1]}
            ${mediasFakesQueries[2]}
          `}</style>
        </Head>   
      
    </>)
  }
}


PPCCMS.propTypes = {
  Component: PropTypes.any.isRequired,
  creativityId: PropTypes.string.isRequired,
  kind: PropTypes.string
}

PPCCMS.defaultProps = {
  kind: 'creativity'
}

const mapStateToProps = (state) => ({
  custoParams: state.custo.custoParams,
  creativities: state.custo.creativities,
  creativitiesOverride: state.custo.creativitiesOverride,
  editMode: state.custo.editMode,
  allowEdit: state.custo.allowEdit,
  context: state.main.context,
});

const mapDispatchToProps = (dispatch) => ({
  getCreativity: data => dispatch(custoActions.getCreativity(data)),
  launchEditModal: (data) => dispatch(modalActions.addModal(data)),
  setDraftChange: (draftData) => dispatch(custoActions.setDraftChange(draftData)),
  applySessionDraft: data => dispatch(custoActions.applySessionDraft(data)),
  setEditMode: flag => dispatch(custoActions.setEditMode(flag)),
  sendCmsEvent: taggingInfo => dispatch(mainActions.sendCmsEvent(taggingInfo))
});


export default connect(mapStateToProps, mapDispatchToProps)(PPCCMS)

